import { Country, EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { Segment, SegmentEntity, WithSegmentBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { PlaidAccessTokenStatus } from './plaid.access-token.status.enum';
import { PlaidAccessTokenAccount, PlaidAccessTokenAccountSchema } from './plaid.access-token.account';
import { PlaidInstitution, PlaidPlaidInstitutionSchema } from './plaid.access-token.institution';

export const PlaidAccessTokenSchema = WithSegmentBaseEntitySchema(
    z.object({
        buyer: z.string(),
        accessToken: z.string(),
        itemId: z.string().optional(),
        status: EnumSchema(PlaidAccessTokenStatus).optional(),
        expirationDate: z.string().nullish(),
        accounts: z.array(PlaidAccessTokenAccountSchema).optional(),
        country: EnumSchema(Country).nullish(),
        institution: PlaidPlaidInstitutionSchema.nullish(),
    }),
).strict();

export class PlaidAccessToken extends FromSchema(PlaidAccessTokenSchema) implements SegmentEntity {
    id: string;

    accessToken: string;
    buyer: string;
    itemId?: string;
    status?: PlaidAccessTokenStatus;
    expirationDate?: string;
    accounts?: PlaidAccessTokenAccount[];
    institution?: PlaidInstitution;

    segments?: Segment[];
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
